import {
  getGoalKey,
  toneVariant,
  useCompanionNoun,
} from '@/utils/personalization'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🔌',
    title: 'pages.onboarding.challenge.disconnected',
    value: 'disconnected',
  },
  {
    emoji: '😴',
    title: 'pages.onboarding.challenge.motivation',
    value: 'motivation',
  },
  {
    emoji: '💔',
    title: 'pages.onboarding.challenge.relationship',
    value: 'relationship',
  },
  {
    emoji: '🧭',
    title: 'pages.onboarding.challenge.uncertain',
    value: 'uncertain',
  },
  { emoji: '🏋️', title: 'pages.onboarding.challenge.health', value: 'health' },
  {
    emoji: '🔍',
    title: 'pages.onboarding.challenge.purpose',
    value: 'purpose',
  },
]

export default function ChallengeQuestionPage() {
  const noun = useCompanionNoun()
  const goal = getGoalKey()

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.challenge.title"
      subtitle={toneVariant(`pages.onboarding.challenge.subtitle_${goal}`)}
      translationInterpolation={{ noun }}
    />
  )
}
